import { CostCenterPriceModel } from "../archive/cost-center-price.model";
import { ServiceModel } from "./service.model";

export class ServiceDetailModel {
  serviceDetailId: number = 0;
  serviceId: number = 0;
  service: ServiceModel = new ServiceModel();
  articleId: number = 0;
  unitId: number = 0;
  conceptInvoicingId: number = 0;
  storeId: number = 0;
  document: string | null = null;
  dateInitial: Date = new Date();
  dateFinal: Date = new Date();
  hourMeterInitial: number | null = null;
  hourMeterFinal: number | null = null;
  realQuantity: number = 0;
  quantity: number = 0;
  unitValue: number = 0;
  swToInvoice: boolean = true;
  createDate: string = "";
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;

  costCenterPrice: CostCenterPriceModel = new CostCenterPriceModel();
  //Se utilizan para mostrar informacion en la captura de datos;
  quantityPending: number = 0;
}